import React from 'react';
import type { TooltipProps as AntdTooltipProps } from 'antd';
import Tooltip from 'components/common/tooltip';

/**
 * Takes antd's Tooltip props for the call sites outside `components/common` written against antd
 * (APO-550), and renders the common Tooltip. Moving those sites onto the wrapper removes this adapter.
 */
const BridgedTooltip: React.FC<AntdTooltipProps> = props => {
  const { title, placement, open, onOpenChange, trigger, mouseEnterDelay, children } = props;

  return (
    <Tooltip
      title={title}
      // The wrapper makes placement required where antd defaults it; defaulting here rather than at
      // each call site removes the chance of a missed site silently moving its tooltip.
      placement={placement ?? 'top'}
      open={open}
      onOpenChange={onOpenChange}
      trigger={trigger}
      mouseEnterDelay={mouseEnterDelay}>
      {children}
    </Tooltip>
  );
};

export default BridgedTooltip;
